import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { WebappAuthProvider } from '@klpkonsern/auth-core';
import { ClientProvider } from '@klp/core/app';
import { App } from '@klp/core/app/App';
import { KlpTheme, EnvironmentIndicator } from '@klp/design/index';
import { FileProvider } from '@klp/file/context/FileContext';

import { SessionExpiryModal } from '../auth';
import { Store } from '../store';

import { MittleieforholdApp } from './MittLeieforholdApp';
import '../i18n/config';

import './index.scss';

// Application entrypoint
ReactDOM.render(
    <BrowserRouter>
        <Provider store={Store}>
            <KlpTheme>
                <EnvironmentIndicator />
                <WebappAuthProvider
                    config={{
                        components: {
                            SessionExpiryModal,
                        },
                    }}
                >
                    <App>
                        <FileProvider>
                            <ClientProvider>
                                <MittleieforholdApp />
                            </ClientProvider>
                        </FileProvider>
                    </App>
                </WebappAuthProvider>
            </KlpTheme>
        </Provider>
    </BrowserRouter>,
    document.getElementById('appRoot') as HTMLElement,
);
